import {
  useCreateMatterFile,
  useCreateMatterFileReference,
} from "@/lib/data/react-query/matters/matter-file";
import type { Matter, MatterSubItemType } from "@/lib/types";
import { getMatterFileReferenceParentPayload } from "@/lib/utils/matterFile";
import { forwardRef, useImperativeHandle, useRef } from "react";

export interface MatterSubItemFileReferenceUploadHandle {
  openFilePicker: () => void;
}

interface MatterSubItemFileReferenceUploadProps {
  matter: Matter;
  subItem: {
    id: string;
    type: MatterSubItemType;
  };
}

export const MatterSubItemFileReferenceUpload = forwardRef<
  MatterSubItemFileReferenceUploadHandle,
  MatterSubItemFileReferenceUploadProps
>(({ matter, subItem }, ref) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const createMatterFile = useCreateMatterFile({ showToast: false });
  const createMatterFileReference = useCreateMatterFileReference();

  useImperativeHandle(ref, () => ({
    openFilePicker: () => {
      fileInputRef.current?.click();
    },
  }));

  return (
    <input
      ref={fileInputRef}
      type="file"
      className="hidden"
      multiple
      onChange={(event) => {
        const files = Array.from(event.target.files ?? []);
        event.target.value = "";

        void Promise.all(
          files.map(async (file) => {
            const createdFile = await createMatterFile.mutateAsync({
              matterId: matter.id,
              isFolder: false,
              idLocation: "",
              name: file.name,
              file,
            });

            await createMatterFileReference.mutateAsync({
              matterId: matter.id,
              fileId: createdFile.data.id,
              ...getMatterFileReferenceParentPayload(subItem),
            });
          }),
        );
      }}
    />
  );
});

MatterSubItemFileReferenceUpload.displayName =
  "MatterSubItemFileReferenceUpload";
